import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const HeroMetricStyled = styled.div`
  width: 100%;
  min-width: 180px;
  border-radius: 12px;
  ${(props) => props.theme.boxShadows.shadowLarge}
  padding: 20px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
`;

export const HeroMetricTitle = styled.p`
  display: flex;
  align-items: center;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  overflow: hidden;
  white-space: nowrap;
  margin: 0 10px 0 0;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const HeroMetricTitleIcon = styled.i<{
  size?: string;
}>`
  font-size: ${(props) => props.size};
  margin: 0px 5px 0 0;
`;

export const HeroMetricSubtitle = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const HeroMetricTitleDescriptor = styled.span`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin-left: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const HeroMetricValue = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH2)}
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const HeroMetricTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const HeroMetricMetricContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

export const HeroMetricMetric = styled.div`
  min-width: 50%;
  &:first-child {
    padding-right: 20px;
  }
`;
